export default "__VITE_ASSET__ZcZW3twp__"